var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterfall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 536.923 173.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.101 0 16.15 0 16.15 16.168 7.036 16.168 7.036 0 .084 0 .084 23.115 23.101 23.115 23.101 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.577 0 76.625 0 76.625 16.168 67.512 16.168 67.512 0 60.56 0 60.56 23.115 83.577 23.115 83.577 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.053 0 137.101 0 137.101 16.168 127.988 16.168 127.988 0 121.036 0 121.036 23.115 144.053 23.115 144.053 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.088 37.223 23.088 30.272 .057 30.276 0 53.307 23.12 53.312 23.12 46.36 6.951 46.36 6.951 37.223 23.088 37.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.707 37.223 83.707 30.272 60.676 30.276 60.619 53.307 83.739 53.312 83.739 46.36 67.571 46.36 67.571 37.223 83.707 37.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.044 37.223 144.044 30.272 121.014 30.276 120.957 53.307 144.076 53.312 144.076 46.36 127.908 46.36 127.908 37.223 144.044 37.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.31 7.026 174.31 .074 151.28 .079 151.223 23.11 174.342 23.115 174.342 16.163 158.174 16.163 158.174 7.026 174.31 7.026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.834 7.026 113.834 .074 90.804 .079 90.747 23.11 113.866 23.115 113.866 16.163 97.698 16.163 97.698 7.026 113.834 7.026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.358 7.026 53.358 .074 30.328 .079 30.271 23.11 53.391 23.115 53.391 16.163 37.222 16.163 37.222 7.026 53.358 7.026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.577 60.149 76.625 60.149 76.625 76.317 67.512 76.317 67.512 60.149 60.56 60.149 60.56 83.264 83.577 83.264 83.577 60.149"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.283 30.197 46.331 30.197 46.331 46.365 37.217 46.365 37.217 30.197 30.266 30.197 30.266 53.312 53.283 53.312 53.283 30.197"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.334 30.197 167.382 30.197 167.382 46.365 158.268 46.365 158.268 30.197 151.316 30.197 151.316 53.312 174.334 53.312 174.334 30.197"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.594 97.373 83.594 90.421 60.563 90.426 60.506 113.456 83.626 113.461 83.626 106.51 67.457 106.51 67.457 97.373 83.594 97.373"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.334 90.347 167.382 90.347 167.382 106.515 158.268 106.515 158.268 90.347 151.316 90.347 151.316 113.461 174.334 113.461 174.334 90.347"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.334 150.872 167.382 150.872 167.382 167.04 158.268 167.04 158.268 150.872 151.316 150.872 151.316 173.987 174.334 173.987 174.334 150.872"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.31 67.175 174.31 60.223 151.28 60.228 151.223 83.259 174.342 83.264 174.342 76.312 158.174 76.312 158.174 67.175 174.31 67.175"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.358 67.175 53.358 60.223 30.328 60.228 30.271 83.259 53.391 83.264 53.391 76.312 37.222 76.312 37.222 67.175 53.358 67.175"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.31 127.7 174.31 120.749 151.28 120.754 151.223 143.784 174.342 143.789 174.342 136.838 158.174 136.838 158.174 127.7 174.31 127.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "204.489 0 197.537 0 197.537 16.168 188.424 16.168 188.424 0 181.472 0 181.472 23.115 204.489 23.115 204.489 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.965 0 258.013 0 258.013 16.168 248.9 16.168 248.9 0 241.948 0 241.948 23.115 264.965 23.115 264.965 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "325.441 0 318.489 0 318.489 16.168 309.375 16.168 309.375 0 302.424 0 302.424 23.115 325.441 23.115 325.441 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "204.476 37.223 204.476 30.272 181.445 30.276 181.388 53.307 204.508 53.312 204.508 46.36 188.339 46.36 188.339 37.223 204.476 37.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "265.095 37.223 265.095 30.272 242.064 30.276 242.007 53.307 265.127 53.312 265.127 46.36 248.959 46.36 248.959 37.223 265.095 37.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "325.432 37.223 325.432 30.272 302.401 30.276 302.344 53.307 325.464 53.312 325.464 46.36 309.296 46.36 309.296 37.223 325.432 37.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.698 7.026 355.698 .074 332.667 .079 332.61 23.11 355.73 23.115 355.73 16.163 339.562 16.163 339.562 7.026 355.698 7.026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "295.222 7.026 295.222 .074 272.191 .079 272.134 23.11 295.254 23.115 295.254 16.163 279.086 16.163 279.086 7.026 295.222 7.026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "234.746 7.026 234.746 .074 211.716 .079 211.659 23.11 234.778 23.115 234.778 16.163 218.61 16.163 218.61 7.026 234.746 7.026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "204.489 60.149 197.537 60.149 197.537 76.317 188.424 76.317 188.424 60.149 181.472 60.149 181.472 83.264 204.489 83.264 204.489 60.149"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.965 60.149 258.013 60.149 258.013 76.317 248.9 76.317 248.9 60.149 241.948 60.149 241.948 83.264 264.965 83.264 264.965 60.149"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "234.671 30.197 227.719 30.197 227.719 46.365 218.605 46.365 218.605 30.197 211.654 30.197 211.654 53.312 234.671 53.312 234.671 30.197"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "295.196 30.197 288.244 30.197 288.244 46.365 279.131 46.365 279.131 30.197 272.179 30.197 272.179 53.312 295.196 53.312 295.196 30.197"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.721 30.197 348.77 30.197 348.77 46.365 339.656 46.365 339.656 30.197 332.704 30.197 332.704 53.312 355.721 53.312 355.721 30.197"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "204.476 97.373 204.476 90.421 181.445 90.426 181.388 113.456 204.508 113.461 204.508 106.51 188.339 106.51 188.339 97.373 204.476 97.373"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.982 97.373 264.982 90.421 241.951 90.426 241.894 113.456 265.014 113.461 265.014 106.51 248.845 106.51 248.845 97.373 264.982 97.373"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "325.488 97.373 325.488 90.421 302.457 90.426 302.4 113.456 325.52 113.461 325.52 106.51 309.351 106.51 309.351 97.373 325.488 97.373"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "325.441 60.149 318.489 60.149 318.489 76.317 309.375 76.317 309.375 60.149 302.424 60.149 302.424 83.264 325.441 83.264 325.441 60.149"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.698 67.175 355.698 60.223 332.667 60.228 332.61 83.259 355.73 83.264 355.73 76.312 339.562 76.312 339.562 67.175 355.698 67.175"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "295.222 67.175 295.222 60.223 272.191 60.228 272.134 83.259 295.254 83.264 295.254 76.312 279.086 76.312 279.086 67.175 295.222 67.175"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "234.746 67.175 234.746 60.223 211.716 60.228 211.659 83.259 234.778 83.264 234.778 76.312 218.61 76.312 218.61 67.175 234.746 67.175"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "325.441 120.675 318.489 120.675 318.489 136.842 309.375 136.842 309.375 120.675 302.424 120.675 302.424 143.789 325.441 143.789 325.441 120.675"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "385.682 0 378.73 0 378.73 16.168 369.616 16.168 369.616 0 362.665 0 362.665 23.115 385.682 23.115 385.682 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "446.158 0 439.206 0 439.206 16.168 430.092 16.168 430.092 0 423.14 0 423.14 23.115 446.158 23.115 446.158 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "506.634 0 499.682 0 499.682 16.168 490.568 16.168 490.568 0 483.616 0 483.616 23.115 506.634 23.115 506.634 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "385.668 37.223 385.668 30.272 362.638 30.276 362.581 53.307 385.7 53.312 385.7 46.36 369.532 46.36 369.532 37.223 385.668 37.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "446.288 37.223 446.288 30.272 423.257 30.276 423.2 53.307 446.32 53.312 446.32 46.36 430.151 46.36 430.151 37.223 446.288 37.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "506.625 37.223 506.625 30.272 483.594 30.276 483.537 53.307 506.657 53.312 506.657 46.36 490.489 46.36 490.489 37.223 506.625 37.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "536.891 7.026 536.891 .074 513.86 .079 513.803 23.11 536.923 23.115 536.923 16.163 520.755 16.163 520.755 7.026 536.891 7.026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "476.415 7.026 476.415 .074 453.384 .079 453.327 23.11 476.447 23.115 476.447 16.163 460.279 16.163 460.279 7.026 476.415 7.026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "415.939 7.026 415.939 .074 392.908 .079 392.851 23.11 415.971 23.115 415.971 16.163 399.803 16.163 399.803 7.026 415.939 7.026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "446.158 60.149 439.206 60.149 439.206 76.317 430.092 76.317 430.092 60.149 423.14 60.149 423.14 83.264 446.158 83.264 446.158 60.149"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "476.389 30.197 469.437 30.197 469.437 46.365 460.323 46.365 460.323 30.197 453.371 30.197 453.371 53.312 476.389 53.312 476.389 30.197"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "536.914 30.197 529.962 30.197 529.962 46.365 520.849 46.365 520.849 30.197 513.897 30.197 513.897 53.312 536.914 53.312 536.914 30.197"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "446.174 97.373 446.174 90.421 423.144 90.426 423.087 113.456 446.206 113.461 446.206 106.51 430.038 106.51 430.038 97.373 446.174 97.373"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "506.68 97.373 506.68 90.421 483.65 90.426 483.593 113.456 506.712 113.461 506.712 106.51 490.544 106.51 490.544 97.373 506.68 97.373"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "536.914 90.347 529.962 90.347 529.962 106.515 520.849 106.515 520.849 90.347 513.897 90.347 513.897 113.461 536.914 113.461 536.914 90.347"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "446.174 157.898 446.174 150.946 423.144 150.951 423.087 173.982 446.206 173.987 446.206 167.035 430.038 167.035 430.038 157.898 446.174 157.898"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "506.634 60.149 499.682 60.149 499.682 76.317 490.568 76.317 490.568 60.149 483.616 60.149 483.616 83.264 506.634 83.264 506.634 60.149"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "536.891 67.175 536.891 60.223 513.86 60.228 513.803 83.259 536.923 83.264 536.923 76.312 520.755 76.312 520.755 67.175 536.891 67.175"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "476.415 67.175 476.415 60.223 453.384 60.228 453.327 83.259 476.447 83.264 476.447 76.312 460.279 76.312 460.279 67.175 476.415 67.175"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "446.158 120.675 439.206 120.675 439.206 136.842 430.092 136.842 430.092 120.675 423.14 120.675 423.14 143.789 446.158 143.789 446.158 120.675"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "506.634 120.675 499.682 120.675 499.682 136.842 490.568 136.842 490.568 120.675 483.616 120.675 483.616 143.789 506.634 143.789 506.634 120.675"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterfall);
export default __webpack_public_path__ + "static/media/waterfall.62a487d8d505da574b5f917e081ad1c1.svg";
export { ForwardRef as ReactComponent };